import { CDN_URL } from '@/configs';

export const SEO_TITLE = 'Alpha';
export const SEO_DESCRIPTION =
  'A radically new way to explore Bitcoin — beyond just a currency.';
export const SEO_IMAGE = `${CDN_URL}/pages/city/metadata-city.png`;
